import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Container, Row, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";

// Actions
import { userList, userDelete } from "../../../store/actions";
import { userFilter } from "../../../store/actions";

// Import common components
import Pagination from "../../../components/Common/Pagination";
import Loader from "../../../components/Common/Loader";
import Table from "../../../components/Common/Table";
import ButtonVolver from "../../../components/ButtonVolver";
import LocationHistoryModal from "./LocationHistoryModal";


const UserList = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const theme = useSelector((state) => state.theme.theme) || "light";

  // Check superadmin
  const authUser = JSON.parse(localStorage.getItem("user")) || {};
  const groups = String(authUser.groups || "");
  const isSuperAdmin = groups.includes("SuperAdmin");

  useEffect(() => {
    dispatch(userList());
  }, [dispatch]);

  const [search, setSearch] = useState("");

  //Delete
  const [confirmText, setConfirmText] = useState(false);
  const [confirmDel, setConfirmDel] = useState("");
  const [cancel, setCancel] = useState(false);

  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyUser, setHistoryUser] = useState(null);

  // Interaction Modal logic
  const [interactionModalOpen, setInteractionModalOpen] = useState(false);
  const [interactionMonthYear, setInteractionMonthYear] = useState("");

  const toggleInteractionModal = () => setInteractionModalOpen(!interactionModalOpen);

  const handleDownloadInteractions = () => {
    if (!interactionMonthYear) {
      toast.error("Por favor seleccione un mes y año");
      return;
    }
    const [year, month] = interactionMonthYear.split("-");
    const downloadUrl = `https://www.newlimpiaback.da2soft.com/api/reportes/user-interactions-month-excel/?year=${year}&month=${month}`;
    window.open(downloadUrl, "_blank");
    toggleInteractionModal();
  };

  const toggleHistoryModal = () => setHistoryModalOpen(!historyModalOpen);

  const handleHistory = (user) => {
    setHistoryUser(user);
    setHistoryModalOpen(true);
  };




  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const handleConfirm = (id) => {
    setConfirmText(true);
    setConfirmDel(id);
  };



  const params = {
    count: props.user.count,
    next: props.user.next,
    previous: props.user.previous,
    results: props.user.results,
  };

  const columns = [
    { key: "first_name", label: "Nombres", filterable: true },
    { key: "username", label: "Username", filterable: true },
    { key: "contactType", label: "Tipo Contacto", filterable: true },
    { key: "codigoCAUAGENT", label: "Código CAU", filterable: true },
    { key: "codigo_visitador", label: "Código Visitador", filterable: true },
    { key: "cargo", label: "Cargo", filterable: true },
    { key: "firma", label: "Firma", filterable: false },
    { key: "rol", label: "Rol", filterable: true },
    { key: "acciones", label: "Acción", filterable: false },
  ];

  const formattedData = Array.isArray(params.results)
    ? params.results
      .filter((user) => user.username !== "Admin@grupoda2.com") // Filtrar el usuario admin
      .map((user) => ({
        ...user,
        contactType: user.contactType || "No especificado",
        codigoCAUAGENT: (() => {
          if (!user.codigoCAUAGENT) return "No asignado";
          if (Array.isArray(user.codigoCAUAGENT)) {
            return user.codigoCAUAGENT.join(", ");
          }
          if (typeof user.codigoCAUAGENT === 'string') {
            try {
              const parsed = JSON.parse(user.codigoCAUAGENT);
              return Array.isArray(parsed) ? parsed.join(", ") : user.codigoCAUAGENT;
            } catch {
              return user.codigoCAUAGENT;
            }
          }
          return user.codigoCAUAGENT;
        })(),
        codigo_visitador: user.codigo_visitador || "No asignado",
        cargo: user.cargo || "No especificado",
        firma: user.firma ? (
          <span className="text-success">
            <i className="mdi mdi-check-circle me-1"></i>
            Registrada
          </span>
        ) : (
          <span className="text-muted">
            <i className="mdi mdi-close-circle me-1"></i>
            Sin firma
          </span>
        ),
        acciones: (
          <div className="d-flex gap-2">
            <Link to={`/users/${user.id}/edit_user`} title="Editar Usuario">
              <span className="fa fa-edit fa-lg align-middle text-primary"></span>
            </Link>
            <Link to={`/rol/update_rol/${user.id}`} title="Modificar Rol">
              <span className="fa fa-user-tag fa-lg align-middle text-warning"></span>
            </Link>
            <Link to="#" onClick={() => handleConfirm(user.id)} title="Eliminar Usuario">
              <span className="fa fa-trash fa-lg align-middle text-danger"></span>
            </Link>
            <Link to="#" onClick={() => handleHistory(user)} title="Ver Historial de Ubicación">
              <span className="fa fa-map-marker-alt fa-lg align-middle text-info"></span>
            </Link>

          </div>
        ),
      }))
    : [];
  console.log(params.results);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cuidad Limpia | Usuarios</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Col className="d-flex gap-3 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Usuarios
            </span>
          </Col>
          <div style={{ width: "100%", paddingBottom: "1.5rem" }}></div>
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card
                style={{ backgroundColor: "transparent", border: "none" }}
                className="col-lg-11 mx-auto "
              >
                {confirmText && (
                  <SweetAlert
                    title="¿Estás seguro de que quieres eliminar este Usuario ?"
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                      dispatch(userDelete(confirmDel));
                    }}
                    onCancel={() => {
                      setConfirmText(false);
                      setCancel(true);
                    }}
                  />
                )}

                {cancel && (
                  <SweetAlert
                    title="Cancelado"
                    warning
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                      setCancel(false);
                    }}
                  >
                    La información de usuario está a salvo
                  </SweetAlert>
                )}

                {props.userDeleted === true && (
                  <SweetAlert
                    title="Hecho!"
                    success
                    showConfirm={true}
                    onConfirm={() => {
                      setConfirmText(false);
                      dispatch(userList());
                    }}
                  >
                    Se ha eliminado el Usuario con éxito!
                  </SweetAlert>
                )}

                {props.error.detail && (
                  <SweetAlert
                    title="Lo Sentimos,"
                    error
                    showConfirm={true}
                    onConfirm={() => {
                      history.push("/users");
                    }}
                  >
                    {props.error.detail}
                  </SweetAlert>
                )}



                <CardBody>
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Col>
                      <h5 className="">Lista de usuarios</h5>
                    </Col>
                    <Col lg={4} className="d-flex justify-content-end gap-2">
                      {isSuperAdmin && (
                        <Button
                          color="info"
                          className="font-size-14 waves-effect waves-light"
                          onClick={toggleInteractionModal}
                        >
                          Iteracciones con el sistema
                        </Button>
                      )}
                      <Link
                        className="btn btn-primary font-size-14 waves-effect waves-light"
                        to="/users/add_user"
                      >
                        Agregar
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {params.count !== 0 ? (
                <>
                  <Table data={formattedData} columns={columns} theme={theme} viewExport={false} viewImport={false} />

                  <div style={{ padding: "1rem" }}>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={30}
                      baseUrl="users/"
                      filterFunction={userFilter}
                    />
                  </div>
                </>
              ) : (
                <CardBody>
                  <h4 className="card-title">No se encontraron resultados</h4>
                </CardBody>
              )}
            </div>
          )}

          <LocationHistoryModal
            isOpen={historyModalOpen}
            toggle={toggleHistoryModal}
            user={historyUser}
          />

          {/* Interaction Modal */}
          <Modal isOpen={interactionModalOpen} toggle={toggleInteractionModal} centered>
            <ModalHeader toggle={toggleInteractionModal}>Descargar Iteracciones</ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label for="monthYearInput">Seleccione Mes y Año</Label>
                <Input
                  type="month"
                  id="monthYearInput"
                  value={interactionMonthYear}
                  onChange={(e) => setInteractionMonthYear(e.target.value)}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleInteractionModal}>Cancelar</Button>
              <Button color="primary" onClick={handleDownloadInteractions}>Descargar</Button>
            </ModalFooter>
          </Modal>

        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, user, userDeleted } = state.User;
  return { error, loading, user, userDeleted };
};

export default withRouter(connect(mapStateToProps)(UserList));
